const survoyorList = (state) => state.survoyorList;


export default {
  survoyorList,
}


// WEBPACK FOOTER //
// ./src/store/modules/survoyor/getters.js